// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shimmer-separator{background-color:#ddd;height:1px;margin:40px 0}", "",{"version":3,"sources":["webpack://./resources/js/assets/shimmer/Separator/separator.scss"],"names":[],"mappings":"AAAA,mBAEE,qBAAA,CADA,UAAA,CAEA,aAAA","sourcesContent":[".shimmer-separator {\n  height: 1px;\n  background-color: #dddddd;\n  margin: 40px 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
